import type {
  UpstreamKeyBucketRecord,
  CreateUpstreamKeyBucketRequest,
  CreateUpstreamKeyBucketResponse,
  DeleteUpstreamKeyBucketResponse,
  ListUpstreamKeyBucketsResponse,
  UpdateUpstreamKeyBucketRequest,
  UpdateUpstreamKeyBucketResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listKeyBuckets(
  upstreamId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<ListUpstreamKeyBucketsResponse> {
  return opsApiRequest<ListUpstreamKeyBucketsResponse>(
    `/v1/ops/upstreams/${upstreamId}/key-buckets`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function createKeyBucket(
  upstreamId: string,
  body: CreateUpstreamKeyBucketRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateUpstreamKeyBucketResponse> {
  return opsApiRequest<CreateUpstreamKeyBucketResponse>(
    `/v1/ops/upstreams/${upstreamId}/key-buckets`,
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}

export function updateKeyBucket(
  upstreamId: string,
  bucketId: string,
  body: UpdateUpstreamKeyBucketRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateUpstreamKeyBucketResponse> {
  return opsApiRequest<UpdateUpstreamKeyBucketResponse>(
    `/v1/ops/upstreams/${upstreamId}/key-buckets/${bucketId}`,
    {
      method: 'PATCH',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}

export function deleteKeyBucket(
  upstreamId: string,
  bucketId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteUpstreamKeyBucketResponse> {
  return opsApiRequest<DeleteUpstreamKeyBucketResponse>(
    `/v1/ops/upstreams/${upstreamId}/key-buckets/${bucketId}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
